import React from 'react'
import LazyHydrate from 'react-lazy-hydration'
import { Oops } from '@/atoms/Oops'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { Seo } from '@/layout/Seo'
import { useCanonicalUrl } from '@/layout/Seo/useCanonicalUrl'
import { useTranslate } from '@/utils/translate/translate-client'
import { FeaturedShowSection } from '@/views/LandingView/FeaturedShowSection'

export const ErrorPageView = () => {
  const { t } = useTranslate('common')
  const url = useCanonicalUrl(`/500`)
  const oopsText = t('500GenericOops', 'Oops, our servers had a little problem')
  const tryAnotherText = t(
    '500GenericTryAnotherText',
    'Try again later or check out one of our record-shattering stories.',
  )

  return (
    <>
      <Seo
        canonical={url}
        description={oopsText}
        noindex
        nofollow
        openGraph={{ title: oopsText, description: oopsText, url }}
        title={oopsText}
      />
      <div className="bg-core-gray-950 text-white">
        <PaddedContainer className="bg-core-gray-950 pt-28">
          <Oops oopsText={oopsText} tryAnotherText={tryAnotherText} />
          <LazyHydrate whenVisible>
            <FeaturedShowSection />
          </LazyHydrate>
        </PaddedContainer>
      </div>
    </>
  )
}
